import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { getLocalCategoriesList } from 'entities/Category';
import { isCategoryUncategorized } from 'entities/Category/lib/isCategoryUncategorized';
import { getSelectedPropertyCatalogId } from 'entities/Property/model/selectors/PropertySelectors';
import { AddPropertyCatalogCategoryAtList } from 'features/addPropertyCatalogCategory';

import { AddCatalogItemCategory } from './AddCatalogItemCategory';

interface CatalogItemCategoryFormBodyProps {
    subtitleOverride?: string;
}

export const CatalogItemCategoryFormBody = ({
    subtitleOverride,
}: CatalogItemCategoryFormBodyProps) => {
    const categories = useSelector(getLocalCategoriesList);
    const catalogId = useSelector(getSelectedPropertyCatalogId);

    return (
        <>
            <AddPropertyCatalogCategoryAtList
                subtitleOverride={subtitleOverride}
            />
            <Box
                data-testid="categories-list"
                display="flex"
                flexDirection="column"
                gap="8px 0"
                mt="14px"
            >
                {categories
                    ? Object.values(categories)
                          .sort((a, b) => {
                              if (isCategoryUncategorized(a.title)) return -1;
                              if (isCategoryUncategorized(b.title)) return 1;
                              return 0;
                          })
                          .map((category) => (
                              <AddCatalogItemCategory
                                  key={category.id}
                                  id={category.id}
                                  color={category.color}
                                  catalogId={catalogId}
                                  title={category.title}
                                  glCode={category.glCode}
                              />
                          ))
                    : null}
            </Box>
        </>
    );
};
